export default __webpack_public_path__ + "static/gary-avatar-0a2d9394f84442bcb11a5df9fa8414c0.png";